<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { VTabListSimple } from '@/modules/shared/components'

const route = useRoute()
const router = useRouter()

const tabs = [
  { label: 'Settings', to: { name: 'workspace.settings' }, isVue: true },
  { label: 'Documents', to: { name: 'investing.documents' }, isVue: true },
  { label: 'Invoices', to: { name: 'investing.invoices' }, isVue: true },
  { label: 'Message Center', to: { name: 'messaging.index' }, isVue: true },
  { label: 'Files', to: { name: 'filing.group.files-system' }, isVue: true },
  { label: 'Billing', to: { name: 'billing-group' }, isVue: true },
]

const currentIndex = computed(() => {
  const routeName = route.name as string
  if (routeName?.startsWith('workspace.settings')) return 0
  if (routeName === 'investing.documents') return 1
  if (routeName === 'investing.invoices') return 2
  if (routeName?.startsWith('messaging.')) return 3
  if (routeName === 'filing.group.files-system') return 4
  if (routeName?.startsWith('billing-group')) return 5
  return -1
})

const tabLabels = tabs.map((tab) => tab.label)

const redirectPage = (index: number) => {
  const selectedTab = tabs[index]
  if (selectedTab.isVue) {
    router.push(selectedTab.to as { name: string })
  } else {
    window.location.href = selectedTab.to as string
  }
}
</script>

<template>
  <VTabListSimple @update:current="redirectPage" :current="currentIndex" :tabs="tabLabels" class="mb-6" size="base" />
</template>
